import Vue from 'vue'
Vue.filter('currency', function(value) {
  if (!value) return ''
  value = value.toString()
  switch (value) {
    case 'EUR':
      return '€'
    case 'USD':
      return '$'
    default:
      return value
  }
})
